
(function () {
    var directivesModule = angular.module('customeDirectivesModule');

    directivesModule.directive('npGridControl', function () {
        return {
            restrict: 'E',
            controller: ['$scope', '$state', '$timeout', '$filter', '$sce', 'favoriteService', 'documentService', 'configService', controller],
            controllerAs: 'vm',
            templateUrl: paths.GridControlView,
            scope: {
                gridSettingKey: '@',
                columnsDefinition: '=',
                documents: '=',
                groupDocument: '=',
                highlightMissingDocuments: '=',
                onOpenDocument: '&onOpenDocument',
                isProcess: '=',
                onOpenProcess: '&onOpenProcess',
                onOpenProcessArea: '&onOpenProcessArea',
                includeProcess: '=',
                isProcessInterconnected: '=',
                onOpenProcessInterconnected: '&onOpenProcessInterconnected'
            }
        };
    });

    function controller($scope, $state, $timeout, $filter, $sce, favoriteService, documentService, configService) {
        $scope.translation = globalResources;
        $scope.resources = resources;
        $scope.gridSettingKeys = gridSettingKeys;
        $scope.columnsDefinition = $scope.columnsDefinition ? $scope.columnsDefinition : optionalColumnsDenifinition;
        $scope.commonGridSetting = angular.copy(calculateColumnsWidth());
        $scope.openDocument = openDocument;
        $scope.openFolder = openFolder;
        $scope.currentRowIndex = 0;
        var vm = this;
        vm.data = arrayCopy($scope.documents);
        vm.originalData = arrayCopy($scope.documents);
        $scope.total = vm.data != null ? vm.data.length : 0;
        $scope.rowCollection = [];
        $scope.showAllDocuments = showAllDocuments;
        $scope.generateDocumentTooltip = generateDocumentTooltip;
        $scope.generateAttachmentTooltip = generateAttachmentTooltip;
        $scope.viewDocumentFieldDirectly = configService.getBool(HandbookConfiguration.ViewDocumentFieldDirectly) && configService.getBool(HandbookConfiguration.EnabledCheckViewDocumentFieldDirectly);
        $scope.selectedColumn = { order: 'descending', key: '' };
        $scope.times = 0;
        $scope.originalCollection = [];
        $scope.showSortIcon = true;
        $scope.isIE = detectIE();
        $scope.reverse = true;
        $scope.openProcess = openProcess;
        $scope.openProcessArea = openProcessArea;
        $scope.openProcessInterconnected = openProcessInterconnected;
        vm.maxHeight = '100%';

        vm.isProcess = $scope.isProcess ? true : false;
        vm.includeProcess = $scope.includeProcess ? true : false;
        vm.isProcessInterconnected = $scope.isProcessInterconnected ? true : false;
        var orderBy = $filter('orderBy');
        var infiniteScrollLoadsize = (HandbookConfiguration.InfiniteScrollLoadSize == "0" || HandbookConfiguration.InfiniteScrollLoadSize == 0) ?
            0 :
            parseInt(HandbookConfiguration.InfiniteScrollLoadSize);
        var internetPublishOption = configService.getBool(HandbookConfiguration.InternetPublishOption);
        var publishedVersion = configService.getBool(HandbookConfiguration.PublishedVersion);
        vm.processClassificationTypes = E.processClassificationTypes;

        $scope.$on(broadcastType.gridSettingTarget, function (e, target, gridSettingKey) {
            if (gridSettingKey == $scope.gridSettingKey) {
                $scope.columnsDefinition = optionalColumnsDenifinition;
				$scope.commonGridSetting = angular.copy(calculateColumnsWidth());
            }
        });

        var lastStart = 0;
        $scope.nextPage = function getData(tableState) {
            if (infiniteScrollLoadsize == 0) {
                $scope.rowCollection = vm.data;
                $scope.originalCollection = angular.copy($scope.rowCollection);
            } else {
                //if we reset (like after a search or an order)
                if (tableState.pagination.start === 0) {
                    if ($scope.rowCollection == null || $scope.rowCollection.length == 0) {
                        $scope.rowCollection = getAPage();
                        $scope.originalCollection = angular.copy($scope.rowCollection);
                    }
                } else {
                    //we load more
                    $scope.rowCollection = $scope.rowCollection.concat(getAPage());
                    $scope.originalCollection = angular.copy($scope.rowCollection);
                    $scope.$apply();

                    //remove first nodes if needed
                    /*if (lastStart < tableState.pagination.start && $scope.rowCollection.length > (parseInt(HandbookConfiguration.InfiniteScrollLoadSize) * 2)) {
                        //remove the first nodes
                        $scope.rowCollection.splice(0, parseInt(HandbookConfiguration.InfiniteScrollLoadSize));
                    }*/
                }

                lastStart = tableState.pagination.start;
            }
        };

        $scope.order = function (predicate) {
			$scope.reverse = !$scope.reverse;
			var reverse = $scope.reverse;
            if (predicate == $scope.selectedColumn.key || $scope.selectedColumn.key == "") { // Click header more than one time
                $scope.times +=1;
            } else { // Click another column
                $scope.times = 1;
            }
            $scope.selectedColumn.key = predicate;
            $scope.selectedColumn.order = reverse ? 'descending' : 'ascending';
            if ($scope.times > 2) { 
                $scope.showSortIcon = false;
				vm.data = arrayCopy(vm.originalData);
				$scope.reverse = !$scope.reverse;
                $scope.times = 0;
            } else {
                switch (predicate) {
                    case 'approvedDate':
                        vm.data = arrayCopy(vm.originalData);
                        vm.data.sort(function (x, y) {
                            var d1 = Utils.ToDate(x.approvedDate);
                            var d2 = Utils.ToDate(y.approvedDate);
                            if (reverse) {
                                return d1 > d2 ? -1 : (d1 == d2 ? 0 : 1);
                            } else {
                                return d1 > d2 ? 1 : (d1 == d2 ? 0 : -1);
                            }
                        });
                        break;

                    case 'readingReceiptDtmConfirmed':
                    case 'readingReceipt':
                        vm.data = arrayCopy(vm.originalData);
                        vm.data.sort(function (x, y) {
                            var d1 = Utils.ToDate(x.readingReceiptDtmConfirmed);
                            var d2 = Utils.ToDate(y.readingReceiptDtmConfirmed);
                            if (reverse) {
                                return d1 > d2 ? -1 : (d1 == d2 ? 0 : 1);
                            } else {
                                return d1 > d2 ? 1 : (d1 == d2 ? 0 : -1);
                            }
                        });
                        break;
					case 'internet':
                        vm.data = orderBy(vm.originalData, 'internetDocument', reverse);
						break;

                    default:
                        vm.data = orderBy(vm.originalData, predicate, reverse);
                        break;
                }
                $scope.showSortIcon = true;
            }
            $scope.rowCollection = $scope.currentRowIndex ? vm.data.slice(0, $scope.currentRowIndex) : vm.data.slice(0);;
            $scope.originalCollection = arrayCopy(vm.rowCollection);
        };

        $scope.$watch('documents', function (data) { // This handler for initialize data.
            vm.data = arrayCopy($scope.documents);
            vm.originalData = arrayCopy($scope.documents);
            var newTotal = data != null ? data.length : 0;
            if (infiniteScrollLoadsize == 0) {
                $scope.rowCollection = vm.data;
                $scope.originalCollection = arrayCopy($scope.rowCollection);
            } else {
                if ($scope.rowCollection.length == 0 || $scope.total != newTotal || hasDataChange($scope.rowCollection, vm.data)) {
                    $scope.total = newTotal;
                    $scope.currentRowIndex = 0;
                    $scope.rowCollection = getAPage();
                    $scope.originalCollection = arrayCopy($scope.rowCollection);

                    $timeout(function () { //scroll a bit up
                        var gridBody = angular.element('#' + folderContent.gridDocuments + ' tbody')[0];
                        var scrollTop = gridBody.scrollTop;
                        gridBody.scrollTop -= scrollTop / 2;
                    }, 10, false);
                }
            }
            processChangeHeightForTable();
        });

        function hasDataChange(oldData, newData) {
            for (var i = 0; i < oldData.length; i++) {
                if (oldData[i].id != newData[i].id) {
                    return true;
                }
            }

            return false;
        };

        function showAllDocuments() {
            $scope.rowCollection = vm.data;
            $scope.originalCollection = angular.copy($scope.rowCollection);
            $scope.currentRowIndex = $scope.total;
        }

        $scope.$on('showAllDocumentInGroup', function (e, target) {
            showAllDocuments();
        });
        
		function generateDocumentTooltip(row) {
			var result = "<div class='table-css'>";
			result += getElementForTooltips(globalResources.LinkedVirtually, row.virtual ? globalResources.Yes : globalResources.No);
			result += getElementForTooltips(globalResources.CommonGridColumns.Title, row.name);
			result += getElementForTooltips(globalResources.CommonGridColumns.Type, row.template);
            result += getElementForTooltips(row.isProcess ? globalResources.ProcessArea : globalResources.CommonGridColumns.Chapter, row.folderName);
			result += getElementForTooltips(globalResources.CommonGridColumns.Location, row.location);
            result += getElementForTooltips(globalResources.CommonGridColumns.Version, row.version);
            var documentId = 0;
            if (row.isProcess) {
                documentId = row.processNumber ? row.processNumber : row.processInterconnectedNumber;
            } else {
                documentId = row.documentId;
            }
			result += getElementForTooltips(globalResources.CommonGridColumns.DocumentId, documentId);
            result += getElementForTooltips(globalResources.CommonGridColumns.ApprovedDate, row.approvedDate);
            if (!publishedVersion) {
                result += getElementForTooltips(globalResources.CommonGridColumns.Approver, row.approvedBy);
                result += getElementForTooltips(globalResources.CommonGridColumns.Responsible, row.responsible);
            }

			if ($scope.gridSettingKey == gridSettingKeys.readingListVisibilitySettings) {
				var confirm = row.isConfirmed ? globalResources.Yes : globalResources.No;
				result += getElementForTooltips(globalResources.Confirmed, confirm);
			}
            if (row.readingReceiptDtmConfirmed != null && row.readingReceiptDtmConfirmed != '') {
				result += getElementForTooltips(globalResources.CommonGridColumns.ReadingReceiptDtmCOnfirmedColumnHeader, row.readingReceiptDtmConfirmed);
                if (row.readingReceiptValidity != null && row.readingReceiptValidity != 0 && row.readingReceiptsExpire) {
                    var confirmDate = Utils.ToDate(row.readingReceiptDtmConfirmed);
                    confirmDate.setMonth(confirmDate.getMonth() + row.readingReceiptValidity);
                    result += getElementForTooltips(globalResources.ValidToReading, $filter('date')(confirmDate, 'dd.MM.yyyy'));
                } 
            }
            if (internetPublishOption && !publishedVersion) {
                var internet = ((row.isProcess && row.isInternet) || row.internetDocument) ? globalResources.Yes : globalResources.No;
				result += getElementForTooltips(globalResources.publishedInternet, internet);
            }
            if ($scope.gridSettingKey == gridSettingKeys.readingListVisibilitySettings && $scope.columnsDefinition.readingList) {
                result += getElementForTooltips(globalResources.ReadingLists, (row.readingListName || '').replace(/,/g, ', <br />'));
            }
            result += "</div> ";

            return result;
		}

        $scope.htmlTooltip = $sce.trustAsHtml('I\'ve been made <b>bold</b>!');

        function generateAttachmentTooltip(row) {
            var result = "";
            if (row.agreeFiles && row.agreeFiles.length) {
                result = "<div class='white text-black padding-8'>" + $scope.translation.AgreeFiles + "</div>"
                result += "<div class='attachment-tooltip padding-8'>";
                for (var i = 0; i < row.agreeFiles.length; i++) {
                    result += "    <div>";
                    result += ` <a href='/api/File/GetFile?entityId=${row.agreeFiles[i].itemId}' target='_blank' style='color:white !important;' title='${row.agreeFiles[i].name}'>${row.agreeFiles[i].name}</a>`;
                    result += "    </div>";
                }
                result += "</div>"
            }
            if (row.attachments && row.attachments.length) {
                if (row.isProcess) {
                    result += "<div class='white text-black padding-8'>" + $scope.translation.Attachments + "</div>";
                    result += "<div class='attachment-tooltip padding-8'>";
                    for (var i = 0; i < row.attachments.length; i++) {
                        result += "    <div>";
                        result += `        <a href='/api/processes/GetFileContents?fileId=${row.attachments[i].fileId}' target='_blank' style='color:white !important;' title="${row.attachments[i].fileName}">${row.attachments[i].fileName}</a>`;
                        result += "    </div>";
                    }
                    result += "</div>"
                }
                else {
                    result += "<div class='white text-black padding-8'>" + $scope.translation.Attachments + "</div>";
                    result += "<div class='attachment-tooltip padding-8'>";
                    for (var i = 0; i < row.attachments.length; i++) {
                        result += "    <div>";
                        result += `        <a href='/api/File/GetFile?entityId=${row.attachments[i].itemId}' target='_blank' style='color:white !important;' title="${row.attachments[i].name}">${row.attachments[i].name}</a>`;
                        result += "    </div>";
                    }
                    result += "</div>"
                }
                
            }
            
			return result;
        }

        function getAPage() {
            var data = [];
            var startIndex = $scope.currentRowIndex;
            var endIndex = startIndex + infiniteScrollLoadsize;
            for (var i = startIndex; i < endIndex; i++) {
                if ($scope.currentRowIndex < $scope.total) {
                    data.push(vm.data[i]);
                    $scope.currentRowIndex += 1;
                } else {
                    break;
                }
            }
            return data;
        }
         
        function openDocument(documentId) {
            $scope.onOpenDocument({ id: documentId });
        };

        function openFolder(folderId) {
            $state.go(handbookActions.FolderAction, { folderId: folderId });
        }

        function openProcess(processNumber) {
            $scope.onOpenProcess({ processNumber: processNumber });
        }

        function openProcessArea(id) {
            $scope.onOpenProcessArea({ areaId: id });
        }

        function openProcessInterconnected(processInterconnectedNumber) {
            $scope.onOpenProcessInterconnected({ processInterconnectedNumber: processInterconnectedNumber });
        }

        function calculateColumnsWidth(numColumns, extraWidth) {
            var __numCoumns = numColumns == null ? 0 : numColumns;
            var __extraWidth = extraWidth == null ? 0 : extraWidth;
            var additionWidth = 0;
            if (__numCoumns > 0) {
                additionWidth = (__extraWidth / __numCoumns);
            } 
            var columns = 0; // title column always visible.
            var temp = commonGridSetting;
            var ratio = 100;
            temp.title.width = ratio + '%';
            if ($scope.columnsDefinition.documentType) {
                ratio -= (additionWidth + 12);
                temp.documentType.width = (additionWidth + 12) + '%';
                columns += 1;
            }
            if ($scope.columnsDefinition.chapter) {
                ratio -= (additionWidth + 13);
                temp.chapter.width = (additionWidth + 13) + '%';
                columns += 1;
            }
            if ($scope.columnsDefinition.location) {
                ratio -= (additionWidth + 17);
                temp.location.width = (additionWidth + 17) + '%';
                columns += 1;
            }
            if ($scope.columnsDefinition.approver) {
                ratio -= (additionWidth + 8);
                temp.approver.width = (additionWidth + 8) + '%';
                columns += 1;
            }
            if ($scope.columnsDefinition.responsible) {
                ratio -= (additionWidth + 9);
                temp.responsible.width = (additionWidth + 9) + '%';
                columns += 1;
            }
            if ($scope.columnsDefinition.hasAttachment) {
                ratio -= (additionWidth + 4);
                temp.hasAttachment.width = (additionWidth + 4) + '%';
                columns += 1;
            }
            if ($scope.columnsDefinition.documentId) {
                ratio -= (additionWidth + 5);
                temp.documentId.width = (additionWidth + 5) + '%';
                columns += 1;
            }
            if ($scope.columnsDefinition.version) {
                ratio -= (additionWidth + 7);
                temp.version.width = (additionWidth + 7) + '%';
                columns += 1;
            }
            if ($scope.columnsDefinition.readCount) {
                ratio -= (additionWidth + 5);
                temp.readCount.width = (additionWidth + 5) + '%';
                columns += 1;
            }
            if ($scope.columnsDefinition.approvedDate) {
                ratio -= (additionWidth + 9);
                temp.approvedDate.width = (additionWidth + 9) + '%';
                columns += 1;
            }

            if (ratio > 3) {
                temp.title.width = ratio + '%';
            } else {
                temp.title.width = '100px';
            }
            
            if (ratio > 51 && ratio != 100) {
                temp = calculateColumnsWidth(columns, (ratio - 50));
            }
            return temp;
        };

        function arrayCopy(data) {
            if (data && data.length > 0) {
                return data.slice();
            }
        };

        $scope.$on('processChangeHeightForTable', function (e, target) {
            processChangeHeightForTable();
        });

        function processChangeHeightForTable() {

            if ($scope.groupDocument) {
                if (infiniteScrollLoadsize != 0) {
                    var rows = infiniteScrollLoadsize;
                    vm.maxHeight = (rows * 29.89) + 'px';
                }
                return;
            }
            $timeout(function () { //scroll a bit up
                var gridDocuments = angular.element('#' + folderContent.gridDocuments + '');
                //var parent = gridDocuments.parent().parent().parent();
                var parent = gridDocuments;
                if (parent && parent.position()) {
                    var documentHeight = $(document).height();
                    var contentHeight = documentHeight - parent.position().top;
                    //angular.element('#' + folderContent.gridDocuments + '').css({ maxheight: contentHeight - 20 });
                    vm.maxHeight = (contentHeight - 20) + "px";
                    $scope.$apply();
                }    
            }, 100, false);
        }
        //$('.popover-visible-trigger')
        //    .popover('show')
        //    .off('click');
    }
})();